import React, { useLayoutEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { IFrameModal } from '@adsk/bim360-matrix-react-components';

const IFrameModalWithCallbacks = (props) => {
  const { onIframeOpen, onIframeClose, location, ...rest } = props;
  const iFrameHasUrl = location && location.query && !!location.query.popupViewerUrl;

  const firstMountRef = useRef(true);

  useLayoutEffect(() => {
    // ignoring transition when component mount
    if (firstMountRef.current) {
      firstMountRef.current = false;
      return;
    }

    if (iFrameHasUrl) {
      onIframeOpen();
    } else {
      onIframeClose();
    }
  }, [iFrameHasUrl]);

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <IFrameModal location={location} {...rest} />;
};
IFrameModalWithCallbacks.defaultProps = {
  onIframeOpen: () => {},
  onIframeClose: () => {},
};

IFrameModalWithCallbacks.propTypes = {
  onIframeOpen: PropTypes.func,
  onIframeClose: PropTypes.func,
  location: PropTypes.shape({
    query: PropTypes.shape({
      popupViewerUrl: PropTypes.string,
    }),
  }).isRequired,
};

export default IFrameModalWithCallbacks;
